import banerCheddarCsFallback from '@/assets/images/temp-banners/banner_cheddar_cs.jpg?w=720'
import banerCheddarCsAvif from '@/assets/images/temp-banners/banner_cheddar_cs.jpg?w=720&format=avif&as=srcset'
import banerCheddarCsWebp from '@/assets/images/temp-banners/banner_cheddar_cs.jpg?w=720&format=webp&as=srcset'
import banerCheddarDeFallback from '@/assets/images/temp-banners/banner_cheddar_de.jpg?w=720'
import banerCheddarDeAvif from '@/assets/images/temp-banners/banner_cheddar_de.jpg?w=720&format=avif&as=srcset'
import banerCheddarDeWebp from '@/assets/images/temp-banners/banner_cheddar_de.jpg?w=720&format=webp&as=srcset'
import banerCheddarHuFallback from '@/assets/images/temp-banners/banner_cheddar_hu.jpg?w=720'
import banerCheddarHuAvif from '@/assets/images/temp-banners/banner_cheddar_hu.jpg?w=720&format=avif&as=srcset'
import banerCheddarHuWebp from '@/assets/images/temp-banners/banner_cheddar_hu.jpg?w=720&format=webp&as=srcset'
import banerCheddarPlFallback from '@/assets/images/temp-banners/banner_cheddar_pl.jpg?w=720'
import banerCheddarPlAvif from '@/assets/images/temp-banners/banner_cheddar_pl.jpg?w=720&format=avif&as=srcset'
import banerCheddarPlWebp from '@/assets/images/temp-banners/banner_cheddar_pl.jpg?w=720&format=webp&as=srcset'
import banerCheddarRoFallback from '@/assets/images/temp-banners/banner_cheddar_ro.jpg?w=720'
import banerCheddarRoAvif from '@/assets/images/temp-banners/banner_cheddar_ro.jpg?w=720&format=avif&as=srcset'
import banerCheddarRoWebp from '@/assets/images/temp-banners/banner_cheddar_ro.jpg?w=720&format=webp&as=srcset'
import banerCheddarSkFallback from '@/assets/images/temp-banners/banner_cheddar_sk.jpg?w=720'
import banerCheddarSkAvif from '@/assets/images/temp-banners/banner_cheddar_sk.jpg?w=720&format=avif&as=srcset'
import banerCheddarSkWebp from '@/assets/images/temp-banners/banner_cheddar_sk.jpg?w=720&format=webp&as=srcset'


import banerCrunchyCsFallback from '@/assets/images/temp-banners/banner_crunchy-corn-piri_cs.jpg?w=720'
import banerCrunchyCsAvif from '@/assets/images/temp-banners/banner_crunchy-corn-piri_cs.jpg?w=720&format=avif&as=srcset'
import banerCrunchyCsWebp from '@/assets/images/temp-banners/banner_crunchy-corn-piri_cs.jpg?w=720&format=webp&as=srcset'
import banerCrunchyDeFallback from '@/assets/images/temp-banners/banner_crunchy-corn-piri_de.jpg?w=720'
import banerCrunchyDeAvif from '@/assets/images/temp-banners/banner_crunchy-corn-piri_de.jpg?w=720&format=avif&as=srcset'
import banerCrunchyDeWebp from '@/assets/images/temp-banners/banner_crunchy-corn-piri_de.jpg?w=720&format=webp&as=srcset'
import banerCrunchyHuFallback from '@/assets/images/temp-banners/banner_crunchy-corn-piri_hu.jpg?w=720'
import banerCrunchyHuAvif from '@/assets/images/temp-banners/banner_crunchy-corn-piri_hu.jpg?w=720&format=avif&as=srcset'
import banerCrunchyHuWebp from '@/assets/images/temp-banners/banner_crunchy-corn-piri_hu.jpg?w=720&format=webp&as=srcset'
import banerCrunchyPlFallback from '@/assets/images/temp-banners/banner_crunchy-corn-piri_pl.jpg?w=720'
import banerCrunchyPlAvif from '@/assets/images/temp-banners/banner_crunchy-corn-piri_pl.jpg?w=720&format=avif&as=srcset'
import banerCrunchyPlWebp from '@/assets/images/temp-banners/banner_crunchy-corn-piri_pl.jpg?w=720&format=webp&as=srcset'
import banerCrunchyRoFallback from '@/assets/images/temp-banners/banner_crunchy-corn-piri_ro.jpg?w=720'
import banerCrunchyRoAvif from '@/assets/images/temp-banners/banner_crunchy-corn-piri_ro.jpg?w=720&format=avif&as=srcset'
import banerCrunchyRoWebp from '@/assets/images/temp-banners/banner_crunchy-corn-piri_ro.jpg?w=720&format=webp&as=srcset'
import banerCrunchySkFallback from '@/assets/images/temp-banners/banner_crunchy-corn-piri_sk.jpg?w=720'
import banerCrunchySkAvif from '@/assets/images/temp-banners/banner_crunchy-corn-piri_sk.jpg?w=720&format=avif&as=srcset'
import banerCrunchySkWebp from '@/assets/images/temp-banners/banner_crunchy-corn-piri_sk.jpg?w=720&format=webp&as=srcset'

export const tempBannersImages = [
  {
    name: 'banner_cheddar_cs.jpg',
    avif: banerCheddarCsAvif,
    webp: banerCheddarCsWebp,
    fallback: banerCheddarCsFallback,
  },
  {
    name: 'banner_cheddar_de.jpg',
    avif: banerCheddarDeAvif,
    webp: banerCheddarDeWebp,
    fallback: banerCheddarDeFallback,
  },
  {
    name: 'banner_cheddar_hu.jpg',
    avif: banerCheddarHuAvif,
    webp: banerCheddarHuWebp,
    fallback: banerCheddarHuFallback,
  },
  {
    name: 'banner_cheddar_pl.jpg',
    avif: banerCheddarPlAvif,
    webp: banerCheddarPlWebp,
    fallback: banerCheddarPlFallback,
  },
  {
    name: 'banner_cheddar_ro.jpg',
    avif: banerCheddarRoAvif,
    webp: banerCheddarRoWebp,
    fallback: banerCheddarRoFallback,
  },
  {
    name: 'banner_cheddar_sk.jpg',
    avif: banerCheddarSkAvif,
    webp: banerCheddarSkWebp,
    fallback: banerCheddarSkFallback,
  },
  {
    name: 'banner_crunchy_cs.jpg',
    avif: banerCrunchyCsAvif,
    webp: banerCrunchyCsWebp,
    fallback: banerCrunchyCsFallback,
  },

  {
    name: 'banner_crunchy_de.jpg',
    avif: banerCrunchyDeAvif,
    webp: banerCrunchyDeWebp,
    fallback: banerCrunchyDeFallback,
  },
  {
    name: 'banner_crunchy_hu.jpg',
    avif: banerCrunchyHuAvif,
    webp: banerCrunchyHuWebp,
    fallback: banerCrunchyHuFallback,
  },
  {
    name: 'banner_crunchy_pl.jpg',
    avif: banerCrunchyPlAvif,
    webp: banerCrunchyPlWebp,
    fallback: banerCrunchyPlFallback,
  },
  {
    name: 'banner_crunchy_ro.jpg',
    avif: banerCrunchyRoAvif,
    webp: banerCrunchyRoWebp,
    fallback: banerCrunchyRoFallback,
  },
  {
    name: 'banner_crunchy_sk.jpg',
    avif: banerCrunchySkAvif,
    webp: banerCrunchySkWebp,
    fallback: banerCrunchySkFallback,
  },
]
